import React, { useState } from 'react';
import { useApiClient, useContextMenu, useFetch } from '@marageti/z4-lib';
import { TeamMember } from '@marageti/z4-sdk/lib/people';
import { enqueueSnackbar } from 'notistack';
import View from './profile-view';
import { useAuthStore } from '../../../store';

const Container = () => {
  const apiClient = useApiClient();
  const { loggedInTeamMember } = useAuthStore();
  const teamMemberId = loggedInTeamMember?.id;

  const { data: teamMember, mutate } = useFetch<TeamMember>(apiClient.peopleClient.getTeamMember, [teamMemberId], !!teamMemberId);

  const [editorOpen, setEditorOpen] = useState(false);
  const [contextMenuAnchor, setContextMenuAnchor, contextMenuOpen] = useContextMenu();

  const handleOpenContextMenu = (e: React.MouseEvent<HTMLButtonElement>) => {
    setContextMenuAnchor(e.currentTarget || null);
  };
  const handleCloseContextMenu = () => setContextMenuAnchor(null);

  const handleCloseEditor = () => {
    setEditorOpen(false);
    handleCloseContextMenu();
  };
  const handleOpenEditor = () => setEditorOpen(true);

  const handleEditAvatar = async (avatar: string) => {
    if (teamMember) {
      try {
        const { avatar: updatedAvatar } = await apiClient.peopleClient.putTeamMemberAvatar(teamMember.id, {
          id: teamMember.id,
          avatar,
        });
        mutate({ ...teamMember, avatar: updatedAvatar }, { revalidate: false });
      } catch (error) {
        enqueueSnackbar('The image could not be uploaded', { variant: 'default' });
      }
    }
  };

  return (
    <View
      contextMenuAnchor={contextMenuAnchor}
      contextMenuOpen={contextMenuOpen}
      editorOpen={editorOpen}
      onCloseContextMenu={handleCloseContextMenu}
      onCloseEditor={handleCloseEditor}
      onEditAvatar={handleEditAvatar}
      onOpenContextMenu={handleOpenContextMenu}
      onOpenEditor={handleOpenEditor}
      teamMember={teamMember}
    />
  );
};

export default Container;
